import React from 'react';

import './CarouselDots.css';

type CarouselDotsProps = {
    count: number;
    activeIndex: number;
    onSelect: (index: number) => void;
    label: (index: number) => string;
    ariaLabel?: string;
    className?: string;
    variant?: 'dot' | 'bar';
    color?: string;
    inactiveOpacity?: number;
    hoverOpacity?: number;
    transitionMs?: number;
    withBackdropBlur?: boolean;
};

export function CarouselDots({
    count,
    activeIndex,
    onSelect,
    label,
    ariaLabel,
    className,
    variant = 'dot',
    color,
    inactiveOpacity,
    hoverOpacity,
    transitionMs,
    withBackdropBlur,
}: CarouselDotsProps) {
    const classes = [
        'carousel-dots',
        `carousel-dots--${variant}`,
        withBackdropBlur ? 'carousel-dots--blur' : undefined,
        className,
    ].filter(Boolean).join(' ');
    const style = {
        ...(color ? { '--carousel-dot-color': color } : {}),
        ...(inactiveOpacity !== undefined ? { '--carousel-dot-opacity': inactiveOpacity } : {}),
        ...(hoverOpacity !== undefined ? { '--carousel-dot-hover-opacity': hoverOpacity } : {}),
        ...(transitionMs !== undefined ? { '--carousel-dot-transition': `${transitionMs}ms` } : {}),
    } as React.CSSProperties;

    return (
        <div className={classes} aria-label={ariaLabel} style={style}>
            {Array.from({ length: count }, (_, i) => (
                <button
                    key={i}
                    type="button"
                    aria-current={i === activeIndex ? 'true' : undefined}
                    aria-label={label(i)}
                    className={`carousel-dots__dot${i === activeIndex ? ' carousel-dots__dot--active' : ''}`}
                    onClick={() => onSelect(i)}
                />
            ))}
        </div>
    );
}
